var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._g(
      _vm._b(
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: "Bewerken",
              expression: "'Bewerken'"
            }
          ],
          staticClass: "btn btn-link",
          attrs: { disabled: _vm.disabled }
        },
        "button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c("font-awesome-icon", {
        style: { color: "#007BFF" },
        attrs: { icon: ["fad", "edit"] }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }